module.exports = __webpack_public_path__ + "img/icon_home_seller_pre.81258fdb.png";